import { GlyphIcon } from '@square/dashboard-protos/models/squareup/bbfrontend/common/glyph/glyph_icon';

// eslint-disable-next-line complexity
export default function bbFrontendGlyphIconToSvg(glyphIcon) {
  switch (glyphIcon) {
    case GlyphIcon.PENCIL_WRITING:
      return '24px-edit-pencil';
    case GlyphIcon.DOGEARED_PAPER:
      return 'dogeared-paper';
    case GlyphIcon.PHONE:
      return 'phone';
    case GlyphIcon.CHECK:
      return '18px-check';
    case GlyphIcon.CHECKMARK_CIRCLE:
      return 'checkmark-circle';
    case GlyphIcon.CARD:
      return '24px-bank-stroked';
    case GlyphIcon.SQUARE_CARD:
      return '24px-debit-card';
    case GlyphIcon.BOLT:
      return '24px-bolt';
    case GlyphIcon.BANK:
      return '24px-bank-stroked';
    case GlyphIcon.PRINT:
      return 'print';
    case GlyphIcon.FILE_DOWNLOAD:
      return 'download-file';
    case GlyphIcon.X_CIRCLE:
      return '24px-x-circle';
    case GlyphIcon.ENVELOPE:
      return '24px-envelope';
    case GlyphIcon.CLOCK:
      return '24px-clock-stroked';
    case GlyphIcon.EXCLAMATION_TRIANGLE:
      return '24px-exclamation-triangle';
    case GlyphIcon.PAPER_CHECK:
      return 'paper-check';
    case GlyphIcon.EXCLAMATION_CIRCLE:
      return '80px-exclamation-circle';
    case GlyphIcon.MONEY_BAG:
      return '24px-money-bag';
    case GlyphIcon.CASH_MULTIPLE:
      return '24px-cash-multiple';
    case GlyphIcon.PERCENTAGE:
      return '24px-percentage';
    case GlyphIcon.CLOUD:
      return '24px-cloud';
    case GlyphIcon.HOME:
      return '24px-home';
    case GlyphIcon.STORE:
      return '24px-store-stroked';
    case GlyphIcon.DOGEARED_PAPER_SIGN_DOLLAR:
      return 'dogeared-paper-sign-dollar';
    case GlyphIcon.LOCK_ON:
      return '24px-lock-stroked';
    case GlyphIcon.FOOD_MENU:
      return 'food-menu';
    case GlyphIcon.HUMAN_COUPLE:
      return 'human-couple';
    case GlyphIcon.EMOTION_HAPPY:
      return 'emotion-happy';
    case GlyphIcon.BUILDINGS:
      return 'buildings';
    case GlyphIcon.SHOPPING_BASKET:
      return 'shopping-basket';
    case GlyphIcon.CAR:
      return 'car';
    case GlyphIcon.BOX:
      return 'box';
    case GlyphIcon.MINUS:
      return 'minus';
    case GlyphIcon.LOUD_SPEAKER:
      return 'loud-speaker';
    case GlyphIcon.FORM:
      return '24px-form';
    case GlyphIcon.SCREWDRIVER_RULER:
      return 'screwdriver-ruler';
    case GlyphIcon.AIRPLANE:
      return 'airplane';
    case GlyphIcon.PHONE_WIRELESS:
      return '24px-phone-wireless';
    case GlyphIcon.MOVING_BOX:
      return 'moving-box';
    case GlyphIcon.DOORDASH:
      return 'doordash';
    case GlyphIcon.UBER_EATS:
      return 'uber-eats';
    case GlyphIcon.GRUBHUB:
      return 'grubhub';
    case GlyphIcon.FOLDER_LOCK:
      return 'folder-lock';
    case GlyphIcon.ROCKET:
      return 'rocket';
    default:
      return '';
  }
}